import {Pipe, PipeTransform} from '@angular/core';


@Pipe({name: 'firstLetterUppercase'})
export class FirstLetterUppercase implements PipeTransform {

	transform(str: string): unknown {
		if (!str) return str;
		return str[0].toUpperCase() + str.substr(1).toLowerCase();
	}
}
